import type React from 'react';

import type { HNCoreFrontendWebForside } from '../types/Resources';

import { selectCurrentLanguage } from '@helsenorge/framework-utils/language';

import ExpanderWarning from './expander-warning';
import Warning from './warning';
import { useAppSelector } from '../store/hooks';
import { useGetTilesQuery } from '../store/tilesApi';

interface UserAccessWarningProps {
  resources: HNCoreFrontendWebForside;
}

const UserAccessWarning: React.FC<UserAccessWarningProps> = props => {
  const language = useAppSelector(state => selectCurrentLanguage(state.language));
  const { data } = useGetTilesQuery(language);

  if (!data) {
    return null;
  }

  if (data.userAccessMessageWarning?.title && data.userAccessMessageWarning?.bodyText) {
    return (
      <ExpanderWarning
        label={data.userAccessMessageWarning.title}
        html={data.userAccessMessageWarning.bodyText}
        resources={props.resources}
      />
    );
  }

  if (data.userAccessMessageWarning?.bodyText) {
    return <Warning html={data.userAccessMessageWarning.bodyText} />;
  }

  return null;
};

export default UserAccessWarning;
